import { render, staticRenderFns } from "./MetricCard.vue?vue&type=template&id=3b7ddb75&scoped=true&"
import script from "./MetricCard.vue?vue&type=script&lang=js&"
export * from "./MetricCard.vue?vue&type=script&lang=js&"
import style0 from "./MetricCard.vue?vue&type=style&index=0&id=3b7ddb75&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ddb75",
  null
  
)

export default component.exports